import React from 'react';
import {Grid} from '@material-ui/core';
import InputField from '../../../../FormikUtils/InputField';
import {useFormikContext} from "formik";
import SlantedField from "../../../../FormikUtils/SlantedField";

export default function SolicitudForm(props) {
    const {
        formField: {
            comentariosSolicitud,
        },
    } = props;
    const {values} = useFormikContext();
    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <SlantedField
                        value={values.premium.toLocaleString('es-ar', {
                            style: 'currency',
                            currency: 'ARS',
                            minimumFractionDigits: 0
                        })}
                        label={'Valor cuota'} />
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <InputField
                        name={comentariosSolicitud.name}
                        label={comentariosSolicitud.label}
                        textTransform={'capitalize'}
                        multiline
                        rows={2}
                        fullWidth
                        onKeyDown={(e) => {
                            if (e.which === 13) {
                                e.preventDefault();
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
